<template>
  <div class="base-card-info steps-items-box">
    <div
      class="steps-items-wrapper"
      :style="maxWidth ? `max-width: ${maxWidth}px;` : undefined"
    >
      <div
        v-for="(v, idx) in steps"
        :key="idx" class="steps-item"
        :class="{
          last: idx === steps.length - 1,
          active: idx <= currentIndex,
          current: idx === currentIndex
        }"
        :style="maxItemWidth ? `max-width: ${maxItemWidth}px;` : 'auto'"
      >
        <div class="step-index">
          {{ idx + 1 }}
        </div>
        <div class="step-name">
          {{ v.title }}
        </div>
        <div v-if="!isNull(v.describe)" class="remark main-primary-text" @click="toStepWith(v.key)">
          {{ v.describe }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { IStepItem } from '../..';
import { computed, PropType } from 'vue';
import { isNull } from '@core/tools';

const emit = defineEmits(['confirm']);

const props = defineProps({
  steps: {
    type: Array as PropType<IStepItem[]>,
    default: () => [],
    required: true,
  },
  activeKey: {
    type: String,
    default: '',
  },
  maxWidth: {
    type: Number,
    default: 0,
  },
  maxItemWidth: {
    type: Number,
    default: 0,
  },
});

const currentIndex = computed(() => props.steps.findIndex((v) => v.key === props.activeKey));

function toStepWith(stepString: string) {
  emit('confirm', stepString);
}
</script>

<style lang="scss" scoped>
.step-name {
  color: #6B7891;
  font-size: 14px;
  padding-top: 8px;
}

.remark {
  cursor: pointer;
}

.step-index {
  width: 24px;
  height: 24px;
  background: #F4F4F5;
  border-radius: 100%;
  border: 1px solid #E9E9EB;
  text-align: center;
  line-height: 24px;
  font-size: 14px;
  color: #909399;
}

.steps-item {
  position: relative;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  user-select: none;

  &::after {
    content: '';
    display: block;
    position: absolute;
    height: 1px;
    background-color: #E4E7ED;
    top: 12px;
    left: 36px;
    width: calc(100% - 50px);
  }

  &.active {
    .step-name {
      font-size: 16px;
      color: #344767;
      font-weight: 600;
    }

    .step-index {
      color: var(--color-primary);
      background: var(--main-item-bg);
      border: 1px solid var(--color-primary-disabled);
    }

    &::after {
      background-color: var(--color-primary);
    }
  }

  &.current {
    .step-index {
      color: #fff;
      background: var(--color-primary);
      border: 1px solid var(--color-primary);
    }

    &::after {
      background-color: #E4E7ED;
    }
  }

  &.last {
    flex: none;

    &::after {
      display: none;
    }
  }
}

.steps-items {
  &-box {
    width: 100%;
    height: 120px;
    box-sizing: border-box;
    padding-top: 32px;
    padding-bottom: 32px;
  }

  &-wrapper {
    width: 100%;
    display: flex;
    margin: 0 auto;
  }
}
</style>
